import React from "react";
import { Box, styled } from "@mui/material";
import type { HatSentiment } from "../../types";

// Uses the same SVG paths and colors as SentimentButtons.tsx

const HeartIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="#EA1D76"
    stroke="#EA1D76"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

const ThumbsUpIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="#078DEE"
    stroke="#078DEE"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
  </svg>
);

const ThumbsDownIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="#FFAB00"
    stroke="#FFAB00"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ transform: "scaleY(-1)" }}
  >
    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
  </svg>
);

const Badge = styled(Box, {
  label: "SentimentBadge",
})(() => ({
  position: "absolute",
  top: 16,
  right: 16,
  width: 40,
  height: 40,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2,
}));

const BADGE_BG: Record<string, string> = {
  LOVE: "#FFF1EE",
  LIKE: "#EBF6FE",
  NOTFORME: "#FFF8EB",
};

export const SentimentBadge = ({
  sentiment,
}: {
  sentiment: HatSentiment | undefined | null;
}) => {
  if (!sentiment) return null;

  return (
    <Badge sx={{ backgroundColor: BADGE_BG[sentiment] || "#f4f6f8" }}>
      {sentiment === "LOVE" && <HeartIcon />}
      {sentiment === "LIKE" && <ThumbsUpIcon />}
      {sentiment === "NOTFORME" && <ThumbsDownIcon />}
    </Badge>
  );
};
